import { useLocation } from '@reach/router';

const useDataScienceProgram = () => {
  const location = useLocation();

  const isDataSciencePage =
    location.pathname === '/ai-data-analytics/' ||
    location.pathname === '/programs/ai-data-analytics/';

  const isDataSciencePpcPage =
    location.pathname === '/programs/ai-data-analytics/';

  const isDataScienceProvisionalPage =
    location.pathname === '/provisional-enrollment/ai-data-analytics/';

  return {
    isDataSciencePage,
    isDataSciencePpcPage,
    isDataScienceProvisionalPage,
  };
};

export default useDataScienceProgram;
